import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const PastFinanceManagementHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Past Order List</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default PastFinanceManagementHeader;
